import { getAccountId, getUserId } from 'lib/utils/authentication';
import RelayEnvironment from 'lib/utils/relay';
import { loadQuery } from 'react-relay';
import { TEAM_MEMBERS_QUERY, TEAM_MEMBER_INVITATIONS_QUERY } from 'services/team/team.relay.services';
import { teamMemberInvitationsQuery } from 'services/team/__generated__/teamMemberInvitationsQuery.graphql';
import { teamMembersQuery } from 'services/team/__generated__/teamMembersQuery.graphql';

export const TeamMembershipsPreloadData = Props => {
  const accountId = getAccountId();
  const userId = getUserId();

  return {
    teamMembersQueryRef: loadQuery<teamMembersQuery>(
      RelayEnvironment,
      TEAM_MEMBERS_QUERY,
      {
        first: 10,
        filter: {
          where: {
            accountId: {
              notEqualTo: accountId,
            },
            memberUserId: {
              equalTo: userId,
            },
            deletedAt: {
              isNull: false,
            },
          },
        },
        ordering: [{ sort: 'CREATED_AT', direction: 'DESC' }],
        skip: accountId === '' ? true : false,
      },
      { fetchPolicy: 'store-or-network' },
    ),

    teamMemberInvitationsQueryRef: loadQuery<teamMemberInvitationsQuery>(
      RelayEnvironment,
      TEAM_MEMBER_INVITATIONS_QUERY,
      {
        first: 10,
        filter: {
          where: {
            accountId: {
              notEqualTo: accountId,
            },
            memberUserId: {
              equalTo: userId,
            },
            accepted: {
              equalTo: false,
            },
            deletedAt: {
              isNull: false,
            },
          },
        },
        ordering: [{ sort: 'CREATED_AT', direction: 'DESC' }],
        skip: accountId === '' ? true : false,
      },
      { fetchPolicy: 'store-or-network' },
    ),
  };
};

export type TeamMembershipsPreloadDataType = ReturnType<typeof TeamMembershipsPreloadData>;
